/**
 * Format Short Social Security Number
 * for example: 1 4 8 8
 *
 * @param {string} ssn
 * @param {string} defaultValue
 * @return {string}
 */
export const formatShortSSN = (ssn, defaultValue = '') => (ssn ? ssn.split('').join(' ') : defaultValue)

/**
 * Format Social Security Number
 * for example: 111-22-3333
 *
 * @param {string} ssn
 * @param {string} defaultValue
 * @return {string}
 */
export const formatSSN = (ssn, defaultValue = '') =>
  ssn
    ? ssn
        .slice(0, 9)
        .replace(/(\d{3}|\d{2}|\d{1})(\d{2}|\d{1})?(\d{4}|\d{3}|\d{2}|\d{1})?/gm, (fullMatch, $1, $2, $3) => {
          if ($3) {
            return `${$1} - ${$2} - ${$3}`
          }

          if ($2) {
            return `${$1} - ${$2}`
          }

          if ($1) {
            return $1
          }

          return ''
        })
    : defaultValue
